/* Health Routine — collection hi-fi behavior */
(function(){
  const root = document.querySelector('[data-section-type="collection-hifi"]');
  if(!root) return;

  /* View toggle */
  const seg = root.querySelector('[data-view-seg]');
  const grid = root.querySelector('[data-grid]');
  if(seg && grid){
    seg.addEventListener('click', e=>{
      const btn = e.target.closest('button'); if(!btn) return;
      seg.querySelectorAll('button').forEach(b=>b.classList.remove('on'));
      btn.classList.add('on');
      root.classList.toggle('collection-hifi--cols-4', btn.dataset.view==='dense');
      root.classList.toggle('ch-density-compact', btn.dataset.view==='dense');
    });
  }

  /* Sort dropdown */
  const sortWrap = root.querySelector('[data-sort]');
  if(sortWrap){
    const toggle = sortWrap.querySelector('[data-sort-toggle]');
    const menu = sortWrap.querySelector('[data-sort-menu]');
    toggle.addEventListener('click', ()=> menu.hidden = !menu.hidden );
    document.addEventListener('click', e=>{ if(!sortWrap.contains(e.target)) menu.hidden = true; });
  }

  /* Star ratings from data-rating */
  root.querySelectorAll('[data-rating]').forEach(el=>{
    const r = parseFloat(el.dataset.rating)||0;
    const full = Math.round(r);
    const host = el.querySelector('.stars');
    if(!host) return;
    let html = '';
    for(let i=1;i<=5;i++){
      html += `<span style="color:${i<=full?'var(--ch-ink)':'var(--ch-ink-4)'}"><svg viewBox="0 0 24 24"><path d="M12 3l2.6 5.7 6.2.6-4.7 4.3 1.4 6.1L12 16.8l-5.5 2.9 1.4-6.1-4.7-4.3 6.2-.6L12 3Z"/></svg></span>`;
    }
    host.innerHTML = html;
  });

  /* Quick-add: intercept and POST via fetch so we stay on page */
  root.querySelectorAll('[data-quick-add]').forEach(form=>{
    form.addEventListener('submit', async e=>{
      e.preventDefault();
      const btn = form.querySelector('button');
      const original = btn.innerHTML;
      btn.innerHTML = '<span>Hinzufügen…</span>';
      try{
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method:'POST', body: fd, headers:{'X-Requested-With':'XMLHttpRequest'} });
        if(res.ok){
          btn.innerHTML = '<span>✓ Hinzugefügt</span>';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(()=> btn.innerHTML = original, 1600);
        } else {
          btn.innerHTML = original;
        }
      } catch(err){
        btn.innerHTML = original;
      }
    });
  });

  /* Wishlist / compare — local-storage toggles */
  const lsKey = k => `hr:${k}`;
  const load = k => { try{ return JSON.parse(localStorage.getItem(lsKey(k))||'[]'); }catch(e){ return []; } };
  const save = (k,v) => localStorage.setItem(lsKey(k), JSON.stringify(v));

  function syncButtons(attr, key){
    const ids = load(key);
    root.querySelectorAll(`[${attr}]`).forEach(btn=>{
      const id = btn.getAttribute(attr);
      btn.classList.toggle('active', ids.includes(id));
    });
  }
  syncButtons('data-wishlist', 'wishlist');
  syncButtons('data-compare',  'compare');

  function toggle(attr, key){
    root.addEventListener('click', e=>{
      const btn = e.target.closest(`[${attr}]`); if(!btn) return;
      const id = btn.getAttribute(attr);
      const ids = load(key);
      const i = ids.indexOf(id);
      if(i>=0) ids.splice(i,1); else ids.push(id);
      save(key, ids);
      syncButtons(attr, key);
    });
  }
  toggle('data-wishlist','wishlist');
  toggle('data-compare','compare');

  /* Filter checkbox → navigate to url_to_add/remove (classic Shopify filter pattern) */
  root.querySelectorAll('.ch-facet .check input[type="checkbox"]').forEach(cb=>{
    cb.addEventListener('change', ()=>{
      const target = cb.checked ? cb.dataset.filterUrl : cb.dataset.filterRemove;
      if(target) window.location.href = target;
    });
  });

  /* Price range: keep handle positions in sync with inputs (read-only UX; submit on blur) */
  root.querySelectorAll('[data-range]').forEach(track=>{
    const facet = track.closest('.ch-facet');
    const inputs = facet.querySelectorAll('.ch-price__field input');
    const fill = track.querySelector('.range-fill');
    const minDot = track.querySelector('[data-dot="min"]');
    const maxDot = track.querySelector('[data-dot="max"]');
    // Submit on Enter by posting to current URL with params
    inputs.forEach(inp=>{
      inp.addEventListener('keydown', e=>{
        if(e.key === 'Enter'){
          e.preventDefault();
          const url = new URL(window.location.href);
          inputs.forEach(i=> url.searchParams.set(i.name, Math.round(parseFloat(i.value)*100)||''));
          window.location.href = url.toString();
        }
      });
    });
  });

  /* Mobile filter drawer trigger (theme-provided <filter-drawer> in classic themes) */
  const openDrawer = root.querySelector('[data-open-drawer]');
  if(openDrawer){
    openDrawer.addEventListener('click', ()=>{
      document.dispatchEvent(new CustomEvent('filter-drawer:open'));
    });
  }
})();
